import { AccountType } from "./getAccountType";
import { showAutopayForCardAccount } from "./showAutopayForCardAccount";
var shouldShowAutopay = function (_a) {
    var accountType = _a.accountType, isAutopayStatusUndefined = _a.isAutopayStatusUndefined, unformattedCurrentBalance = _a.unformattedCurrentBalance, isPastDue = _a.isPastDue, isPreDelivery = _a.isPreDelivery, isAutopayButtonVisible = _a.isAutopayButtonVisible, conditions = _a.conditions, customerAssistancePlan = _a.customerAssistancePlan, settlementEnrolled = _a.settlementEnrolled, isDCEEnabled = _a.isDCEEnabled, isRegistered = _a.isRegistered, hasAutopayCallback = _a.hasAutopayCallback, isUPAG = _a.isUPAG;
    if (isAutopayStatusUndefined)
        return false;
    if (!isAutopayButtonVisible)
        return false;
    var positiveCurrentBalance = Number(unformattedCurrentBalance) > 0;
    if (accountType === AccountType.LOAN ||
        accountType === AccountType.PAY_IN_4) {
        return !!((positiveCurrentBalance || isPreDelivery) && !isPastDue);
    }
    if (accountType === AccountType.SECURED_INSTALLMENT_LOAN) {
        return !!(positiveCurrentBalance && !isPastDue);
    }
    if (accountType === AccountType.CARD) {
        return showAutopayForCardAccount({
            isAutopayStatusUndefined: isAutopayStatusUndefined,
            isPastDue: isPastDue,
            conditions: conditions,
            customerAssistancePlan: customerAssistancePlan,
            settlementEnrolled: settlementEnrolled,
            isAutopayButtonVisible: isAutopayButtonVisible,
            isDCEEnabled: isDCEEnabled,
            isRegistered: isRegistered,
            hasAutopayCallback: Boolean(hasAutopayCallback),
            isUPAG: isUPAG,
        });
    }
    return false;
};
export default shouldShowAutopay;
//# sourceMappingURL=shouldShowAutopay.js.map